import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-item-day" }

import { getCurrentInstance, computed } from 'vue';
import { getDay } from 'date-fns';

export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarViewHeader',
  props: {
  shortFormat: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;
const _this = getCurrentInstance()!.proxy as any;

const currentDate = Date.now();

const currentDayOfWeek = getDay(currentDate);

const showWeekend = computed(() => _this.$store.getters.getShowWeekends);

const daysArray = computed(() => {
  return (
    props.shortFormat ? _this.translate('daysAbbreviationLong') : _this.translate('weekDays')
  ).split(',');
});

const daysLabels = computed(() => {
  return showWeekend.value ? daysArray.value : daysArray.value.slice(0, 5);
});

// currentDayOfWeek is 0 based (sunday is 0, monday is 1, etc.)
const currentDayIndex = computed(() => {
  return currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-view-header usn", { 'grid-cols-7': showWeekend.value }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(daysLabels.value, (day, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass([{ 'active-header-item': currentDayIndex.value === index }, "calendar-view-header-item"])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(day), 1)
      ], 2))
    }), 128))
  ], 2))
}
}

})